import React from 'react';
import {CopyToClipboard} from 'react-copy-to-clipboard';

import IconIg from './assets/instagram.png';
import IconBRI from './assets/bri.png';
import { styButtonWrapper } from './styles';

function ButtonLive() {
  return (
    <div className="row">
      <div className="col-md-12">
        {/*<p className="text__live">Hadir secara virtual melalui siaran langsung instagram: </p>*/}
        <CopyToClipboard text="105801008180537">
          <div css={styButtonWrapper}>
            <div className="img__wrapper">
              <img src={IconBRI} alt="TF BRI" />
                <button>Copy Text</button>
            </div>
          </div>
        </CopyToClipboard> 
      </div>
    </div>
  );
}

export default React.memo(ButtonLive);
